import * as React from 'react';
import moment from 'moment';

import { FormField } from 'components/form';
import DatePickerSingle from 'components/date-picker/date-picker-single/DatePickerSingleLazy';

import { __t, applyTranslations } from 'utils/language';
import { HTML_DATE_FORMAT, MIN_USER_AGE, getHTMLDate } from 'utils/date';
import { isRequired } from 'utils/validators';

applyTranslations(require('./profile-date-of-birth.i18n.json'));

import type { InfluencerProfileForm } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const MSG_KEY = 'profile_date_of_birth';

const ProfileDateOfBirth: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const handleChange = (
    date?: string | null
  ): void => {
    const value = getHTMLDate(date);

    onChange({
      influencerDateOfBirth: value
    });
  };

  return (
    <div className="profile-date-of-birth">
      <FormField
        label={__t(`${MSG_KEY}.labels.date_of_birth`)}
        labelType="highlighted"
        direction="column"
        showValidationIcon={false}
        showRequiredMark
        className="profile-date-of-birth__field"
        validators={[
          isRequired(
            profile.influencerDateOfBirth,
            __t(`${MSG_KEY}.errors.date_of_birth`)
          )
        ]}
      >
        <DatePickerSingle
          name="influencerDateOfBirth"
          date={profile.influencerDateOfBirth}
          maxAllowableDate={moment().subtract(MIN_USER_AGE, 'y').format(HTML_DATE_FORMAT)}
          onChange={handleChange}
        />
      </FormField>
    </div>
  );
};

export default ProfileDateOfBirth;
